import React, { useCallback } from "react";

import Form, { FormProps } from "antd/es/form";

import { addSchemeToUrlIfEmpty } from "@mapmycustomers/shared/util/url";

import { useConfigProvider } from "../../../../../ConfigProvider";
import Modal from "../../../../../Modal";
import UrlFormItem from "../../UrlFormItem";

interface FormValues {
  url: string;
}

interface ImageLinkModalProps {
  initialUrl?: string;
  onCancel: () => void;
  onOk: (url: string) => void;
}

const ImageLinkModal = ({ initialUrl, onCancel, onOk }: ImageLinkModalProps) => {
  const configProvider = useConfigProvider();

  const [form] = Form.useForm<FormValues>();

  const handleOkClick = useCallback(() => {
    form.submit();
  }, [form]);

  const handleFormFinish: FormProps<FormValues>["onFinish"] = useCallback<
    NonNullable<FormProps<FormValues>["onFinish"]>
  >(
    (values) => {
      onOk(addSchemeToUrlIfEmpty(values.url));
    },
    [onOk]
  );

  return (
    <Modal
      cancelButtonProps={{ hidden: true }}
      okText={configProvider.formatMessage("ui.emailBody.imageModal.ok")}
      onCancel={onCancel}
      onOk={handleOkClick}
      open
      title={configProvider.formatMessage("ui.emailBody.imageModal.linkTitle")}
    >
      <Form
        form={form}
        initialValues={{ url: initialUrl }}
        layout="vertical"
        onFinish={handleFormFinish}
      >
        <UrlFormItem required />
      </Form>
    </Modal>
  );
};

export default ImageLinkModal;
